export interface ListDockerImagesQueryRequest {
    accountUuid: string;
    includeSharedDockerImages?: boolean;
    offset?: number;
    limit?: number;
}

export class DockerImageDto {
    constructor(private readonly _object: Record<string, any>) {
    }

    get id(): string {
        return this.uuid;
    }

    get uuid(): string {
        return this._object['uuid'] || '';
    }

    get name(): string {
        return this._object['name'] || '';
    }

    get tag(): string {
        return this._object['tag'] || '';
    }

    get digest(): string {
        return this._object['digest'] || '';
    }

    get sizeInBytes(): number {
        return this._object['sizeInBytes'] ?? null;
    }

    get sizeInMB(): number {
        if (this.sizeInBytes === null) {
            return null;
        }
        return Math.round((this.sizeInBytes / (1024 * 1024)) * 100) / 100;
    }

    get displayName(): string {
        return [this.name, this.tag].filter(Boolean).join(':');
    }

    get private(): boolean {
        return !!this._object['private'];
    }

    get accountUuid(): string {
        return this._object['accountUuid'] || '';
    }

    get createdAt(): Date {
        return this._object['createdAt'] ? new Date(this._object['createdAt']) : null;
    }

    get updatedAt(): Date {
        return this._object['updatedAt'] ? new Date(this._object['updatedAt']) : null;
    }

    get raw(): Record<string, any> {
        return this._object;
    }
}
